import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { COMPANY, NAV, PORTS, WHATSAPP_LINK_SUSHANT } from "@/data/site";
import { Wordmark } from "@/components/Header";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-navy-deep text-white">
        <div className="mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 lg:px-12 lg:py-24">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <Wordmark light />
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/65">
                        {COMPANY.name} — {COMPANY.type}. Dependable agri-commodity exports from Rajasthan, India, for
                        global feed mills, commodity importers, and trading companies.
                    </p>
                    <div className="mt-7 flex flex-wrap gap-3">
                        <WhatsAppButton label="WhatsApp Puneet" location="footer-puneet" />
                        <WhatsAppButton label="WhatsApp Sushant" location="footer-sushant" variant="white" href={WHATSAPP_LINK_SUSHANT} />
                    </div>
                </div>
                <div className="lg:col-span-2">
                    <h3 className="font-display text-xs font-bold uppercase tracking-[0.22em] text-amber">Navigate</h3>
                    <ul className="mt-5 space-y-2.5">
                        {NAV.map((item) => (
                            <li key={item.path}>
                                <Link
                                    to={item.path}
                                    data-testid={`footer-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`}
                                    className="text-sm text-white/70 transition-colors hover:text-white"
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="lg:col-span-3">
                    <h3 className="font-display text-xs font-bold uppercase tracking-[0.22em] text-amber">Contact</h3>
                    <ul className="mt-5 space-y-4 text-sm text-white/70">
                        <li className="flex gap-3">
                            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-steel" />
                            <span>{COMPANY.address}</span>
                        </li>
                        <li className="flex gap-3">
                            <Mail className="mt-0.5 h-4 w-4 shrink-0 text-steel" />
                            <a href={`mailto:${COMPANY.email}`} data-testid="footer-email-link" className="transition-colors hover:text-white">
                                {COMPANY.email}
                            </a>
                        </li>
                        <li className="flex gap-3">
                            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-steel" />
                            <span>
                                Puneet Aggarwal:{" "}
                                <a href="tel:+919602655086" data-testid="footer-phone-link" className="transition-colors hover:text-white">
                                    {COMPANY.phone}
                                </a>
                            </span>
                        </li>
                        <li className="flex gap-3">
                            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-steel" />
                            <span>
                                Sushant Lohia:{" "}
                                <a href="tel:+917340211436" data-testid="footer-phone-sushant-link" className="transition-colors hover:text-white">
                                    +91 7340211436
                                </a>
                            </span>
                        </li>
                    </ul>
                </div>
                <div className="lg:col-span-3">
                    <h3 className="font-display text-xs font-bold uppercase tracking-[0.22em] text-amber">Compliance</h3>
                    <ul className="mt-5 space-y-2.5 text-sm text-white/70">
                        <li data-testid="footer-gst">GST: {COMPANY.gst}</li>
                        <li data-testid="footer-iec">IEC: {COMPANY.iec}</li>
                        <li>LLP Registration — Verified &amp; Active</li>
                        <li>Batch-wise COA support on every shipment</li>
                    </ul>
                </div>
            </div>
            <div className="mt-16 border-t border-white/10 pt-8">
                <p className="text-xs uppercase tracking-[0.18em] text-white/45">
                    Ports served: {PORTS.join(", ").replace("Kandla/Deendayal", "Kandla")}
                </p>
                <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-sm text-white/60">© 2026 AXORA PS GLOBAL LLP. All rights reserved.</p>
                    <p className="text-xs text-white/40">{COMPANY.hours}</p>
                </div>
            </div>
        </div>
    </footer>
);
